/** Cryptographic hex string from `byteCount` random bytes (2 hex chars per byte). */
export function randomHex(byteCount: number): string {
	const bytes = new Uint8Array(byteCount);
	if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
		crypto.getRandomValues(bytes);
	}
	return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}
